import { Observable } from 'relay-runtime';
import fetch from 'node-fetch';
import { SubscriptionClient } from 'subscriptions-transport-ws';
import { GRAPHQL_ENDPOINT, GRAPHQL_SUBSCRIPTION_ENDPOINT } from './constants';

async function fetchQuery(operation, variables) {
  return await fetch(GRAPHQL_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: operation.text,
      variables,
    }),
  }).then(async response => {
    return await response.json();
  });
}

const setupSubscription = (config, variables, cacheConfig, observer) => {
  const query = config.text;

  const subscriptionClient = new SubscriptionClient(
    GRAPHQL_SUBSCRIPTION_ENDPOINT,
    { reconnect: true },
  );
  return Observable.create(sink => {
    const c = subscriptionClient.request({ query, variables }).subscribe(sink);
    return c;
  });
};

export { fetchQuery, setupSubscription };
